import { __, jsonToData } from "src/libs/utilities"
import { IPETest, PETestQuestionAnswer } from "../interfaces"

export function getCVGData( resultString: string, test:IPETest, userName?: string ): any[] {  

    // console.log( jsonToData( resultString ) )
    const cvg: any[] = jsonToData( resultString ).map((c: any) => {
        if(!c) {
            return { [ __("Answer") ]: "", [ __("Value") ]: 0 }
        }
        let answer: PETestQuestionAnswer = {} as PETestQuestionAnswer

        let elem: any = { [ __("Answer") ]: c.answer_id, [ __("Value") ]: c.value }
        const question = test.questions.find(q => {
            let _answer = q.answers.find( a => (c.answer_id === a.id) )
            if( !!_answer ) {
                answer = {..._answer}
                //console.log( answer )
                return true
            }
            return false
        })
        if( !!answer ) {
            // console.log( answer ) 
            elem[ __("Answer") ] = answer.title
        }
        if(!!question) {
            elem[ __("Value") ] = Math.round(c.value / 100 * question.range)
        }        
        return elem
    })

    return cvg
}

export function getAnswerCategoryData( resultString: string, test:IPETest, userName?: string ): any[] {  

    //console.log( jsonToData( resultString ) )
    const cvg: any[] = jsonToData( resultString ).map((c: any) => {
        if(!c) {
            return { "cat_id" : "", value: 0 }
        }
        let answer: PETestQuestionAnswer = {} as PETestQuestionAnswer

        let elem: any = { "cat_id": c.answer_id, value: c.value }
        const question = test.questions.find(q => {
            let _answer = q.answers.find( a => (c.answer_id === a.id) )
            if( !!_answer ) {
                answer = {..._answer}
                //console.log( answer )
                return true
            }
            return false
        })
        if( !!answer ) {
            // console.log( answer ) 
            elem[ "cat_id" ] = answer.pe_test_category?.length ? answer.pe_test_category[0].id : 0
        }
        if(!!question) {
            elem[ "value" ] = Math.round(c.value / 100 * question.range)
        }        
        return elem
    })

    return cvg
}